import React from 'react';
import {
  SiReact,
  SiVuedotjs,
  SiAngular,
  SiNodedotjs,
  SiPython,
  SiPhp,
  SiDotnet,
  SiDocker,
  SiKubernetes,
  SiGooglecloud,
} from 'react-icons/si';
import { FaAws } from 'react-icons/fa';
import { TbBrandAzure } from 'react-icons/tb';

const STACK = [
  { label: 'React', icon: SiReact },
  { label: 'Vue', icon: SiVuedotjs },
  { label: 'Angular', icon: SiAngular },
  { label: 'Node', icon: SiNodedotjs },
  { label: 'Python', icon: SiPython },
  { label: 'PHP', icon: SiPhp },
  { label: '.NET', icon: SiDotnet },
];

const CLOUD = [
  { label: 'AWS', icon: FaAws },
  { label: 'Google Cloud', icon: SiGooglecloud },
  { label: 'Azure', icon: TbBrandAzure },
  { label: 'Docker', icon: SiDocker },
  { label: 'Kubernetes', icon: SiKubernetes },
];

// Entra desde Servicios (borde izquierdo), traza un cuadrado cerrado y desde
// su esquina opuesta cruza hasta el borde derecho para bajar hacia
// Beneficios por el lado contrario. Violeta para leerse sobre fondo negro.
const StackCircuit = () => (
  <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
    {/* conector de entrada, mismo x que el borde de salida de Servicios */}
    <div className="absolute left-4 top-0 h-8 w-[1.5px] bg-[#8B5CF6] opacity-40" />
    {/* cuadrado cerrado (32x32), pegado arriba del todo -- el lado izquierdo
        ya lo traza el conector de entrada */}
    <div className="absolute left-4 top-8 w-8 h-[1.5px] bg-[#8B5CF6] opacity-40" />
    <div className="absolute left-12 top-8 h-8 w-[1.5px] bg-[#8B5CF6] opacity-40" />
    <div className="absolute left-4 top-16 w-8 h-[1.5px] bg-[#8B5CF6] opacity-40" />
    {/* desde la esquina inferior derecha del cuadrado, cruza hasta el borde
        derecho y baja */}
    <div className="absolute left-12 right-10 top-16 h-[1.5px] bg-[#8B5CF6] opacity-40" />
    <div className="absolute right-10 top-16 bottom-16 w-[1.5px] bg-[#8B5CF6] opacity-40" />
    {/* cerca del fondo, cruza de vuelta hacia la izquierda y baja hasta el
        fondo real de la sección para entrar a Beneficios por ese lado */}
    <div className="absolute left-4 right-10 bottom-16 h-[1.5px] bg-[#8B5CF6] opacity-40" />
    <div className="absolute left-4 bottom-0 h-16 w-[1.5px] bg-[#8B5CF6] opacity-40" />
    {/* nodo en la esquina donde el conector de entrada gira hacia el cuadrado */}
    <div className="absolute left-[10px] top-[27px] w-[11px] h-[11px] rounded-full bg-[#A78BFA] opacity-90" />
    {/* nodo en la esquina donde el cruce horizontal gira hacia la bajada derecha */}
    <div className="absolute right-[35px] top-[59px] w-[11px] h-[11px] rounded-full bg-[#A78BFA] opacity-90" />
  </div>
);

const LogoRow = ({ items }) => (
  <div className="flex flex-wrap justify-center gap-4 sm:gap-5">
    {items.map(({ label, icon: Icon }) => (
      <div key={label} className="flex flex-col items-center gap-2.5 w-[104px]">
        <div className="rounded-2xl bg-white w-full aspect-square flex items-center justify-center">
          <Icon className="w-7 h-7 sm:w-8 sm:h-8 text-black" />
        </div>
        <span className="text-white/70 text-[12px] sm:text-[13px] font-medium text-center leading-tight">
          {label}
        </span>
      </div>
    ))}
  </div>
);

const MainframeStackSection = () => {
  return (
    <section className="relative z-[1] bg-black px-5 sm:px-8 md:px-10 py-20 sm:py-28 overflow-hidden">
      <StackCircuit />
      <div className="relative z-10 max-w-3xl mx-auto text-center mb-14 sm:mb-16">
        <h2
          style={{ fontSize: 'clamp(26px, 4.2vw, 44px)', lineHeight: 1.15, fontWeight: 500, letterSpacing: '-0.01em' }}
          className="text-white mb-6"
        >
          Cualquier stack, cualquier nube.
        </h2>
        <p className="text-white/60 text-[15px] sm:text-[16px] leading-relaxed max-w-xl mx-auto">
          Trabajamos con el lenguaje y framework que ya usas, y desplegamos donde tu operación lo
          necesite: AWS, Google Cloud, Azure o tu propia infraestructura.
        </p>
      </div>

      <div className="relative z-10 flex flex-col items-center gap-8 sm:gap-10">
        <LogoRow items={STACK} />
        <LogoRow items={CLOUD} />
      </div>
    </section>
  );
};

export default MainframeStackSection;
